// Aba ScontiPoste no painel do Manager (adesao ao canal)
const channelSellerDictES = {
  settingsTabScontiPoste: "ScontiPoste",
  channelSellerTitle: "Vende en ScontiPoste",
  channelSellerIntro: "ScontiPoste es el programa de cashback de Poste Italiane para titulares de tarjetas Postepay y BancoPosta. Al adherirte, tus productos aptos aparecen en el escaparate Extraconomy para ScontiPoste.",
  channelSellerOnlyManagers: "Solo los Managers pueden vender en ScontiPoste.",
  channelSellerEligibleCount: "Productos aptos: {count}",
  channelSellerListedCount: "Productos en el escaparate: {count}",
  channelSellerNoEligible: "Todavía no hay productos aptos. Mira abajo qué le falta a cada producto.",
  channelSellerTerms: "Condiciones",
  channelSellerTerm1: "En cada venta en ScontiPoste se te descuenta el {percent}% del valor de los productos como cashback ScontiPoste. Se lo abona al cliente Poste Italiane.",
  channelSellerTerm2: "La comisión de Extraconomy y las comisiones de la red no cambian.",
  channelSellerTerm3: "Solo vendes productos en euros, con envío gratis a tu cargo o recogida en tienda.",
  channelSellerTerm4: "Puedes salir cuando quieras: los productos desaparecen del escaparate al momento y los pedidos ya recibidos siguen pendientes de entrega.",
  channelSellerTermsOutdated: "El cashback ScontiPoste ha cambiado al {percent}%. Tus productos están fuera del escaparate hasta que aceptes el nuevo porcentaje.",
  channelSellerAcceptNew: "Aceptar el {percent}%",
  channelSellerAccept: "Acepto las condiciones de venta en ScontiPoste",
  channelSellerMode: "Qué mostrar en el escaparate",
  channelSellerModeAll: "Todos los productos aptos, también los que añada después",
  channelSellerModeSelected: "Solo los productos que elija",
  channelSellerJoin: "Adherirme a ScontiPoste",
  channelSellerJoined: "Estás en ScontiPoste desde el {date}, con un {percent}% de cashback.",
  channelSellerChannelInactive: "El escaparate ScontiPoste todavía no está abierto al público: tus productos aparecerán cuando abra.",
  channelSellerOpenShowcase: "Abrir el escaparate",
  channelSellerProducts: "Tus productos",
  channelSellerSave: "Guardar productos",
  channelSellerSaved: "Productos guardados",
  channelSellerLeave: "Salir de ScontiPoste",
  channelSellerLeaveConfirm: "Tus productos desaparecen del escaparate ScontiPoste al momento. Los pedidos ya recibidos siguen pendientes de entrega. ¿Quieres salir?",
  channelSellerLeft: "Has salido de ScontiPoste",
  channelSellerJoinedToast: "Adhesión confirmada",
  channelSellerAcceptRequired: "Acepta las condiciones para adherirte.",
  channelReasonSELLER_TYPE: "Solo Manager",
  channelReasonNOT_PUBLISHED: "No publicado",
  channelReasonSHIPPING_OPTION: "Envío de pago: usa envío gratis o recogida en tienda",
  channelReasonCURRENCY: "Precio no en euros",
  channelReasonDOWNLOADABLE: "Producto digital",
  channelReasonSERVICE: "Servicio",
  channelReasonDROPSHIPPING: "Producto importado (dropshipping)",
  channelReasonOUT_OF_STOCK: "Agotado",
  channelError500435: "Solo los Managers pueden vender en ScontiPoste.",
  channelError500436: "Acepta las condiciones para adherirte.",
  channelError500437: "Todavía no te has adherido a ScontiPoste.",
};

export default channelSellerDictES;
